import { IImage } from '@fdc/types/image-model';
import { JSX } from 'react';

import styles from './image-link.module.scss';

/** Clickable image wrapped in  */
export const LinkImageHorizontalCutoff = ({
  image,
  showLogo,
}: {
  image: IImage;
  showLogo: boolean;
}): JSX.Element => {
  return (
    <button
      type="button"
      className={styles.imageLink}
      aria-label={image.imgAriaLabel}
      onClick={image.handleCardClickEvent}
    >
      <img
        alt={image.alt}
        src={image.url + (image.size || '')}
        aria-hidden={false}
      />
      {showLogo && <img alt={image.alt} src={image.url} aria-hidden={false} />}
    </button>
  );
};
